import { apiClient } from './apiClient'

/****************************************************************************
 * 
 * Roles
 * 
 ***************************************************************************/

export const roleApi = {
    //XXX TODO this is a guess, I don't have access to this feature in ember to compare
    addRole: async (businessEntityId, role, config, accessToken) => {
        const url = `${config.accountServiceBaseUrl}/api/organizations/${businessEntityId}/roles`
        return await apiClient(
            url,
            accessToken,
            {
                method: "POST",
                headers: {
                    'ClientId': '3'
                },
                body:JSON.stringify(role)
            },
            async (response) => {
                return await response.json().then(
                    (rt) => {
                        return rt.role
                    }
                )
            }
        )
    },
    fetchEphemeralRole: async (businessEntityId, config, accessToken) => {
        const url = `${config.securityApiUrl}/objectRoleMappings?objectId=1&objectTypeId=7`
        return await apiClient(
            url,
            accessToken,
            {
                method: "GET"
            },
            async (response) => {
                return response.json().then(
                    (result) => {
                        return result
                    }
                )
            }
        )
    },
    fetchRole: async (roleId, config, accessToken) => {
        const url = `${config.accountApiUrl}/roles/${roleId}`
        return await apiClient(
            url,
            accessToken,
            {
                method: "GET"
            },
            async (response) => {
                return response.json().then(
                    (result) => {
                        return result.role
                    }
                )
            }
        )
    },
    /**
     * This functions fetches all user/role/business entity intersections for the given BEID
     * Not to be confused with userAction.js's fetchUserRoles, which fetches the endpoint ${config.accountApiUrl}/users/${userId}/roleBusinessEntities to get all roles for a given user ID
     * @param {string} businessEntityId
     * @param {object} config
     * @param {string} accessToken
     * @returns
     */
    fetchUserRoleBusinessEntities: async (businessEntityId, config, accessToken) => {
        const url = `${config.securityApiUrl}/businessentities/${businessEntityId}/userRoleBusinessEntities`
        return await apiClient(
            url,
            accessToken,
            {
                method: "GET"
            },
            async (response) => {
                return response.json().then(
                    (result) => {
                        return result.roleBusinessEntity
                    }
                )
            }
        )
    },
    //XXX TODO this is also a guess
    deleteRole: async (roleId, config, accessToken) => {
        const url = `${config.accountApiUrl}/roles/${roleId}`
        return await apiClient(
            url,
            accessToken,
            {
                method: "POST",
                headers: {
                    'X-HTTP-Method-Override': "DELETE"
                }
            },
            null
        )
    },
    fetchOrganizationRoleList: async (businessEntityId, config, accessToken) => {
        const url = `${config.accountServiceBaseUrl}/api/organizations/${businessEntityId}/roles`
        return await apiClient(
            url,
            accessToken,
            {
                method: "GET"
            },
            async (response) => {
                return await response.json().then(
                    (rt) => {
                        return rt.roles
                    }
                )
            }
        )
    },
    fetchRolePermissions: async (roleId, config, accessToken) => {
        const url = `${config.accountServiceBaseUrl}/api/roles/${roleId}/permissions`
        return await apiClient(
            url,
            accessToken,
            {
                method: "GET"
            },
            async (response) => {
                return await response.json().then(
                    (rt) => {
                        return rt.permissions
                    }
                )
            }
        )
    },
    fetchCanGrantRoleList: async (businessEntityId, config, accessToken) => {
        const url = `${config.accountServiceBaseUrl}/api/organizations/${businessEntityId}/roles?canGrant=true`
        return await apiClient(
            url,
            accessToken,
            {
                method: "GET"
            },
            async (response) => {
                return await response.json().then(
                    (rt) => {
                        return rt.roles
                    }
                )
            }
        )
    }
}